module.exports = __webpack_public_path__ + "img/life-below-water.7c2299b6.png";